import { createContext, useContext } from "react";
import type { ApiEndpoints } from "@avisoma//shared";
import { useQuery, type QueryObserverResult } from "@tanstack/react-query";
import backend from "../services/backend";

interface PlatformContextType {
  categories: QueryObserverResult<
    ApiEndpoints<string>["/api/documents/categories"]["GET"]["response"]
  >;
  tags: QueryObserverResult<
    ApiEndpoints<string>["/api/documents/distinct-tags"]["GET"]["response"]
  >;
}

const PlatformContext = createContext<PlatformContextType | null>(null);

export const PlatformDataProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const categories = useQuery({
    queryKey: ["categories", "list"],
    queryFn: () => {
      return backend.getDocumentsDistinctCategories();
    },
  });

  const tags = useQuery({
    queryKey: ["tags", "list"],
    queryFn: () => {
      return backend.getDocumentsDistinctTags().then((res) => res.data);
    },
  });

  return (
    <PlatformContext.Provider
      value={{
        categories,
        tags,
      }}
    >
      {children}
    </PlatformContext.Provider>
  );
};

export const usePlatformData = () => {
  const context = useContext(PlatformContext);
  if (!context) {
    throw new Error("usePlatform must be used within an PlatformProvider");
  }
  return context;
};
